import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import ToursConfig from "@/pages/config/ToursConfig";
import UsuariosConfig from "@/pages/config/UsuariosConfig";
import ReglasConfig from "@/pages/config/ReglasConfig";
import PlantillasConfig from "@/pages/config/PlantillasConfig";
import AuditoriaConfig from "@/pages/config/AuditoriaConfig";
import BuzonesConfig from "@/pages/config/BuzonesConfig";
import BokunConfig from "@/pages/config/BokunConfig";
import DatosPruebaConfig from "@/pages/config/DatosPruebaConfig";
import AgenciasConfig from "@/pages/config/AgenciasConfig";
import MarcasConfig from "@/pages/config/MarcasConfig";
import BackupConfig from "@/pages/config/BackupConfig";
import { useAuth } from "@/context/AuthContext";
import { MapPinned, Users, SlidersHorizontal, History, Mailbox, Plug, MailPlus, FlaskConical, Building2, AtSign, DatabaseBackup } from "lucide-react";

export default function ConfiguracionPage() {
  const { isAdmin } = useAuth();
  return (
    <div className="space-y-6" data-testid="configuracion-page">
      <div>
        <h2 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">Configuración</h2>
        <p className="text-sm text-slate-500 mt-1">
          Catálogo de tours, usuarios del equipo y reglas globales del sistema.
        </p>
      </div>

      <Tabs defaultValue="tours" className="w-full">
        <TabsList className="bg-slate-100">
          <TabsTrigger value="tours" data-testid="tab-tours" className="gap-2">
            <MapPinned className="h-4 w-4" /> Tours
          </TabsTrigger>
          <TabsTrigger value="usuarios" data-testid="tab-usuarios" className="gap-2">
            <Users className="h-4 w-4" /> Usuarios
          </TabsTrigger>
          <TabsTrigger value="buzones" data-testid="tab-buzones" className="gap-2">
            <Mailbox className="h-4 w-4" /> Buzones
          </TabsTrigger>
          <TabsTrigger value="bokun" data-testid="tab-bokun" className="gap-2">
            <Plug className="h-4 w-4" /> Bokun
          </TabsTrigger>
          <TabsTrigger value="agencias" data-testid="tab-agencias" className="gap-2">
            <Building2 className="h-4 w-4" /> Agencias
          </TabsTrigger>
          <TabsTrigger value="marcas" data-testid="tab-marcas" className="gap-2">
            <AtSign className="h-4 w-4" /> Marcas / Envío
          </TabsTrigger>
          <TabsTrigger value="reglas" data-testid="tab-reglas" className="gap-2">
            <SlidersHorizontal className="h-4 w-4" /> Reglas
          </TabsTrigger>
          <TabsTrigger value="plantillas" data-testid="tab-plantillas" className="gap-2">
            <MailPlus className="h-4 w-4" /> Plantillas
          </TabsTrigger>
          <TabsTrigger value="datos-prueba" data-testid="tab-datos-prueba" className="gap-2">
            <FlaskConical className="h-4 w-4" /> Datos de prueba
          </TabsTrigger>
          <TabsTrigger value="auditoria" data-testid="tab-auditoria" className="gap-2">
            <History className="h-4 w-4" /> Auditoría
          </TabsTrigger>
          {isAdmin && (
            <TabsTrigger value="backup" data-testid="tab-backup" className="gap-2">
              <DatabaseBackup className="h-4 w-4" /> Backup
            </TabsTrigger>
          )}
        </TabsList>

        <TabsContent value="tours" className="mt-6">
          <ToursConfig />
        </TabsContent>
        <TabsContent value="usuarios" className="mt-6">
          <UsuariosConfig />
        </TabsContent>
        <TabsContent value="buzones" className="mt-6">
          <BuzonesConfig />
        </TabsContent>
        <TabsContent value="bokun" className="mt-6">
          <BokunConfig />
        </TabsContent>
        <TabsContent value="agencias" className="mt-6">
          <AgenciasConfig />
        </TabsContent>
        <TabsContent value="marcas" className="mt-6">
          <MarcasConfig />
        </TabsContent>
        <TabsContent value="reglas" className="mt-6">
          <ReglasConfig />
        </TabsContent>
        <TabsContent value="plantillas" className="mt-6">
          <PlantillasConfig />
        </TabsContent>
        <TabsContent value="datos-prueba" className="mt-6">
          <DatosPruebaConfig />
        </TabsContent>
        <TabsContent value="auditoria" className="mt-6">
          <AuditoriaConfig />
        </TabsContent>
        {isAdmin && (
          <TabsContent value="backup" className="mt-6">
            <BackupConfig />
          </TabsContent>
        )}
      </Tabs>
    </div>
  );
}
